import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if you needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('TrackingGuideFiles', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  trackingGuideFiles: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  trackingGuideFiles: state => state.trackingGuideFiles
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
